<template>
  <div>
    <i v-show="!showform" class="far fa-plus-square fa-2x" @click="showform=!showform"></i>
    <i v-show="showform" class="far fa-times-circle fa-2x" @click="showform=!showform"></i>
    <div v-show="showform" class="form-group">
        <input type='file' class='form-control' />
      <input type="text" class="form-control" placeholder="Заголовок">
      <textarea rows="5" class="form-control" placeholder="Описание"></textarea>
      <input type='button' class='btn btn-outline-success' value='Сохранить'>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            showform: 0
        }
    }
};
</script>
